// src/components/FeaturesSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCogs,
  FaServer,
  FaUsersCog,
  FaGlobe,
  FaRobot,
  FaShieldAlt, // added for Cyber Security
} from "react-icons/fa";
import "./FeaturesSection.css";

const FeaturesSection = () => {
  const features = [
    {
      icon: <FaCogs style={{ color: "#d11a1e" }} />,
      title: "Software Transformation",
      text: [
        "ERP & CRM Implementations",
        "SaaS & Cloud Migrations",
        "Legacy System Modernization",
        "AI-Powered Workflows & Automation",
        "Business KPI Frameworks & Dashboards",
      ],
    },
    {
      icon: <FaServer style={{ color: "#d11a1e" }} />,
      title: "IT Infrastructure",
      text: [
        "Fiber Network Deployments (FTTH & Enterprise)",
        "Enterprise Wi-Fi & Secure Connectivity",
        "Data Center & Cloud Infrastructure Integration",
        "Hybrid IT Infrastructure Solutions",
      ],
    },
    {
      icon: <FaUsersCog style={{ color: "#d11a1e" }} />,
      title: "Stakeholder Management",
      text: [
        "Business & Technology Alignment",
        "End-User Adoption & Training Programs",
        "Vendor & Contractor Management",
        "PMO-as-a-Service (Project Management Office)",
      ],
    },
    {
      icon: <FaGlobe style={{ color: "#d11a1e" }} />,
      title: "Global Procurement",
      text: [
        "Sourcing Goods from South Africa*",
        "Supplier Verification & Quality Assurance",
        "End-to-End Logistics Coordination",
        "Cross-Border Procurement & Compliance Support",
      ],
    },
    {
      icon: <FaRobot style={{ color: "#d11a1e" }} />,
      title: "AI Services",
      text: [
        "Transform your operations with smart, scalable AI tools.",
        "Strat Edge now offers cutting-edge AI services",
        "designed to streamline workflows, enhance decision-making,",
        "and unlock new efficiencies across industries.",
      ],
    },
    {
      icon: <FaShieldAlt style={{ color: "#d11a1e" }} />,
      title: "Cyber Security",
      text: [
        "Threat Detection & Incident Response",
        "Network & Endpoint Security",
        "Data Privacy & Compliance",
        "24/7 Security Monitoring & SOC Services",
      ],
    },
  ];

  return (
    <section className="features-section">
      <Container>
        <p className="section-subtitle1 text-center mb-3">Our Expertise</p>
       <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-5">
  {features.map((feature, index) => (
    <Col key={index} className="d-flex align-items-stretch">
      <div className="feature-card h-100">
        <div className="icon">{feature.icon}</div>
        <h5>{feature.title}</h5>
        <ul>
          {feature.text.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
      </div>
    </Col>
  ))}
</Row>

      </Container>
    </section>
  );
};

export default FeaturesSection;
